import { Fade, Typography } from "@mui/material";

import { useAuth, usePromotions } from "../../contexts";
import { PromotionCard } from "../../components";
import * as s from "./styles";
import BannersCrousel from "./components/banners-carousel";
import Header from "./components/header";

const Home = () => {
  const { isVisitant } = useAuth();
  const { loadingPromotions, promotions } = usePromotions();

  return (
    <Fade in timeout={1000}>
      <s.HomeContainer>
        <s.HeaderContainer>
          <Header />
          <BannersCrousel />
        </s.HeaderContainer>
        <s.PromotionsContainer>
          <Typography fontWeight={500}>Promoções</Typography>
          <s.PromotionsList>
            {!loadingPromotions &&
              promotions.map((promotion) => (
                <PromotionCard
                  key={promotion.imageUrl}
                  promotion={promotion}
                  isVisitant={isVisitant}
                />
              ))}
          </s.PromotionsList>
        </s.PromotionsContainer>
      </s.HomeContainer>
    </Fade>
  );
};

export default Home;
